import type { Practitioner } from '@medplum/fhirtypes';
import { getClinical } from '@unify/fhir-model/resources/practitioner';
import { QUALIFICATION_EXT_URLS } from '@unify/fhir-model/constants';

const NP_LICENSE_TYPES = new Set(['psychiatric-np', 'np', 'nurse-practitioner']);

function qualificationLicenseType(practitioner: Practitioner): string | undefined {
  for (const qual of practitioner.qualification ?? []) {
    const fromExt = qual.extension?.find((e) => e.url === QUALIFICATION_EXT_URLS.licenseType)
      ?.valueString;
    if (fromExt?.trim()) return fromExt.trim().toLowerCase();
    const display = qual.code?.coding?.[0]?.display?.trim().toLowerCase();
    if (display?.includes('nurse practitioner') || display === 'np') return display;
  }
  return undefined;
}

/** True when the practitioner is a nurse practitioner (psychiatric NP, etc.). */
export function isNursePractitioner(practitioner: Practitioner | null | undefined): boolean {
  if (!practitioner) return false;
  const licenseType = qualificationLicenseType(practitioner);
  if (licenseType && NP_LICENSE_TYPES.has(licenseType)) return true;
  if (licenseType?.includes('nurse practitioner') || licenseType?.includes('np')) return true;
  const specialties = getClinical(practitioner)?.specialties ?? [];
  return specialties.some((s) => /nurse practitioner|\bnp\b/i.test(s));
}
